import { render } from "./CriarCodigoParceiroModal.vue?vue&type=template&id=6d6a5a02&scoped=true"
import script from "./CriarCodigoParceiroModal.vue?vue&type=script&lang=js"
export * from "./CriarCodigoParceiroModal.vue?vue&type=script&lang=js"

import "./CriarCodigoParceiroModal.vue?vue&type=style&index=0&id=6d6a5a02&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6a5a02"]])

export default __exports__